import { render, staticRenderFns } from "./necessaryUserDetails.vue?vue&type=template&id=38aef588&"
import script from "./necessaryUserDetails.vue?vue&type=script&lang=js&"
export * from "./necessaryUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./necessaryUserDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports